import Cookies from 'js-cookie';

// Set Value in Cookies
export async function setValueInCookies(request) {
    const {token} = await request;
    Cookies.set('token', token, { 
        path: '/', 
        expires: 20, 
        secure: process.env.NODE_ENV === 'production', 
        sameSite: 'strict' 
    });
}

// Get Value from Cookies (async version)
export async function getValueFromCookies(request) {
    const {key} = await request;
    return Cookies.get(key);
}

// Convert into Sub String
export function convertIntoSubString(data) {
    if(data.length > 250) {
        return data.substring(0, 250) + '...';
    }
    return data;
}

// Convert into 120 words
export function convertInto120Words(data) {
    if(data && data.length > 120) {
        return data.substring(0, 120) + '...';
    }
    return data ?? "";
}

// Convert into Sub String for title
export function convertIntoString(data) {
    if(data.length > 60) {
        return data.substring(0, 60) + '...';
    }
    return data;
}

// Get Short Name
export function getShortName(name) {
    if (!name) return "";
    return name
       .split(" ")           // split words
       .map(word => word[0]) // take first character of each word
       .join("")             // join together
       .toUpperCase();       // make sure uppercase
  }